import React from "react"

import { gql, useQuery } from "urql"

import { Size } from "~tailwindui/types/enums"

import { WithLoadingIndicator } from "~tailwindui/Basics"

export const StudyGroupName = ({ id }) => {
  const [result] = useQuery({
    query: studyGroupNameQuery,
    variables: { id },
  })
  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { studyGroup } }) => <span>{studyGroup?.name}</span>}
    </WithLoadingIndicator>
  )
}

const studyGroupNameQuery = gql`
  query StudyGroupBreadcrumb($id: ID!) {
    studyGroup(id: $id) {
      name
    }
  }
`

export const StudentName = ({ id }) => {
  const [result] = useQuery({
    query: studentNameQuery,
    variables: { id },
  })
  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { student } }) => <span>{student?.fullName}</span>}
    </WithLoadingIndicator>
  )
}

const studentNameQuery = gql`
  query StudentBreadcrumb($id: ID!) {
    student(id: $id) {
      fullName
    }
  }
`

export const TierRange = ({ id }) => {
  const [result] = useQuery({
    query: tierRangeQuery,
    variables: { id },
  })
  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { tier } }) => <span>{tier?.gradeRange}</span>}
    </WithLoadingIndicator>
  )
}

const tierRangeQuery = gql`
  query TierBreadcrumb($id: ID!) {
    tier(id: $id) {
      gradeRange
    }
  }
`

export const SessionTitle = ({ id }) => {
  const [result] = useQuery({
    query: sessionQuery,
    variables: { id },
  })
  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { airtutorsSession } }) => (
        <span>
          {airtutorsSession ? (
            <>
              {airtutorsSession?.subject?.name} with{" "}
              {airtutorsSession?.studyGroup?.name ||
                airtutorsSession?.students[0]?.fullName}
            </>
          ) : (
            "Not Found"
          )}
        </span>
      )}
    </WithLoadingIndicator>
  )
}

const sessionQuery = gql`
  query SessionBreadcrumb($id: ID!) {
    airtutorsSession(id: $id) {
      subject {
        name
      }
      studyGroup {
        name
      }
      students {
        fullName
      }
    }
  }
`

export const ExamInstanceName = ({ id }) => {
  const [result] = useQuery({
    query: examInstanceNameQuery,
    variables: { id },
  })
  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { examInstance } }) => <span>{examInstance?.exam?.name}</span>}
    </WithLoadingIndicator>
  )
}

const examInstanceNameQuery = gql`
  query ExamInstanceBreadcrumb($id: ID!) {
    examInstance(id: $id) {
      exam {
        name
      }
    }
  }
`

export const SectionInstanceName = ({ id }) => {
  const [result] = useQuery({
    query: sectionInstanceNameQuery,
    variables: { id },
  })

  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { sectionInstance } }) => (
        <span>{sectionInstance?.section?.subject}</span>
      )}
    </WithLoadingIndicator>
  )
}

const sectionInstanceNameQuery = gql`
  query SectionInstanceBreadcrumb($id: ID!) {
    sectionInstance(id: $id) {
      section {
        subject
      }
    }
  }
`

export const TailoredAssignmentName = ({ id }) => {
  const [result] = useQuery({
    query: tailoredAssignmentNameQuery,
    variables: { id },
  })
  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { tailoredAssignment } }) => (
        <span>{tailoredAssignment?.name}</span>
      )}
    </WithLoadingIndicator>
  )
}

const tailoredAssignmentNameQuery = gql`
  query TailoredAssignmentBreadcrumb($id: ID!) {
    tailoredAssignment(id: $id) {
      name
    }
  }
`

export const TailoredSectionName = ({ id }) => {
  const [result] = useQuery({
    query: tailoredSectionNameQuery,
    variables: { id },
  })
  return (
    <WithLoadingIndicator size={Size.Small} result={result}>
      {({ data: { tailoredSection } }) => <span>{tailoredSection?.name}</span>}
    </WithLoadingIndicator>
  )
}

const tailoredSectionNameQuery = gql`
  query TailoredSectionBreadcrumb($id: ID!) {
    tailoredSection(id: $id) {
      name
    }
  }
`
